/** Supported layout identifiers for route-level layout selection. */
export const LAYOUT_IDS = ['default', 'empty', 'horizontal'] as const;

/** Union type of all supported layout identifiers. */
export type LayoutId = (typeof LAYOUT_IDS)[number];

/** Runtime guard for validating unknown layout values from route data. */
export function isLayoutId(value: unknown): value is LayoutId {
  return typeof value === 'string' && LAYOUT_IDS.includes(value as LayoutId);
}
